<template>
  <div id="home">
    <div class="homeContainer">
      <h1>Bienvenidos a Vetopas</h1>
    </div>
    <div class="hamburgerButton">
      <img id="menuButton" @click="toggleMenu" src="../../../static/images/menu.svg">
    </div>
    <div class="menu">
      <ul>
        <li v-if="hash == 'home'"><a class="activeLink" href="#" v-scroll-to="'#home'">Inicio</a></li>
        <li v-else><a href="#" v-scroll-to="'#home'">Inicio</a></li>
        <li v-if="hash == 'infos'"><a class="activeLink" href="#" v-scroll-to="'#infos'">Informaciones prácticas</a></li>
        <li v-else><a href="#" v-scroll-to="'#infos'">Informaciones prácticas</a></li>
        <li v-if="hash == 'staff'"><a class="activeLink" href="#" v-scroll-to="'#staff'">Nuestro equipo</a></li>
        <li v-else><a href="#" v-scroll-to="'#staff'">Nuestro equipo</a></li>
        <li v-if="hash == 'philosophy'"><a class="activeLink" href="#" v-scroll-to="'#philosophy'">Filosofía</a></li>
        <li v-else><a href="#" v-scroll-to="'#philosophy'">Filosofía</a></li>
        <li v-if="hash == 'servicesHome'"><a class="activeLink" href="#" v-scroll-to="'#servicesHome'">Servicios ofrecidos</a></li>
        <li v-else ><a href="#" v-scroll-to="'#services'">Servicios ofrecidos</a></li>
        <li v-if="hash == 'contactUs'"><a class="activeLink" href="#" v-scroll-to="'#contactUs'">Contáctenos</a></li>
        <li v-else ><a href="#" v-scroll-to="'#contactUs'">Contáctenos</a></li>
        <li v-if="hash == 'order'"><a class="activeLink" href="#" v-scroll-to="'#order'">Pedido</a></li>
        <li v-else ><a href="#" v-scroll-to="'#order'">Pedido</a></li>
      </ul>
    </div>
    <div v-if="menuOpen" class="menuMobile">
      <ul>
        <li v-if="hash == 'home'"><a class="activeLink" href="#" v-scroll-to="'#home'">Inicio</a></li>
        <li v-else><a href="#" v-scroll-to="'#home'">Inicio</a></li>
        <li v-if="hash == 'infos'"><a class="activeLink" href="#" v-scroll-to="'#infos'">Informaciones prácticas</a></li>
        <li v-else><a href="#" v-scroll-to="'#infos'">Informaciones prácticas</a></li>
        <li v-if="hash == 'staff'"><a class="activeLink" href="#" v-scroll-to="'#staff'">Nuestro equipo</a></li>
        <li v-else><a href="#" v-scroll-to="'#staff'">Nuestro equipo</a></li>
        <li v-if="hash == 'philosophy'"><a class="activeLink" href="#" v-scroll-to="'#philosophy'">Filosofía</a></li>
        <li v-else><a href="#" v-scroll-to="'#philosophy'">Filosofía</a></li>
        <li v-if="hash == 'servicesHome'"><a class="activeLink" href="#" v-scroll-to="'#servicesHome'">Servicios ofrecidos</a></li>
        <li v-else ><a href="#" v-scroll-to="'#services'">Servicios ofrecidos</a></li>
        <li v-if="hash == 'contactUs'"><a class="activeLink" href="#" v-scroll-to="'#contactUs'">Contáctenos</a></li>
        <li v-else ><a href="#" v-scroll-to="'#contactUs'">Contáctenos</a></li>
        <li v-if="hash == 'order'"><a class="activeLink" href="#" v-scroll-to="'#order'">Pedido</a></li>
        <li v-else ><a href="#" v-scroll-to="'#order'">Pedido</a></li>
        <li id="close" @click="toggleMenu">Cerrar el menú</li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      hash: 'home',
      screenWidth: document.documentElement.clientWidth,
      screenHeight: window.innerHeight,
      menuOpen: false,
    }
  },
  methods: {
    isScrolledIntoView(el) {
      let elemTop = el.getBoundingClientRect().top
      let elemBottom = el.getBoundingClientRect().bottom
      let elemSize = elemBottom - elemTop
      let isVisible
      if (
        elemSize > window.innerHeight &&
        elemBottom >= window.innerHeight &&
        elemTop <= 0
      ) {
        isVisible = true
      } else if (
        elemSize < window.innerHeight &&
        elemBottom < window.innerHeight &&
        elemTop >= 0
      ) {
        isVisible = true
      } else if (elemTop >= 0) {
        isVisible = true
      } else {
        isVisible = false
      }
      return isVisible
    },
    toggleMenu() {
      this.menuOpen = !this.menuOpen
      console.log("coucou", this.menuOpen)
    }
  },
  mounted() {
    let context = this
    window.setInterval(function() {
      if (context.isScrolledIntoView(document.getElementById('home'))) {
        context.hash = 'home'
      } else if (context.isScrolledIntoView(document.getElementById('infos'))) {
        context.hash = 'infos'
      } else if (
        context.isScrolledIntoView(document.getElementById('staff'))
      ) {
        context.hash = 'staff'
      } else if (
        context.isScrolledIntoView(document.getElementById('philosophy'))
      ) {
        context.hash = 'philosophy'
      } else if (
        context.isScrolledIntoView(document.getElementById('servicesHome'))
      ) {
        context.hash = 'servicesHome'
      } else if (
        context.isScrolledIntoView(document.getElementById('contactUs'))
      ) {
        context.hash = 'contactUs'
      } else if (
        context.isScrolledIntoView(document.getElementById('order'))
      ) {
        context.hash = 'order'
      }
      // this.screenWidth = window.innerWidth ||
      // document.documentElement.clientWidth ||
      // document.getElementsByTagName('body')[0].clientWidth
      // this.screenHeight = window.innerHeight ||
      // document.documentElement.clientHeight ||
      // document.getElementsByTagName('body')[0].clientHeight
      this.screenWidth = document.documentElement.clientWidth
      this.screenHeight = window.innerHeigh
    }, 100)
  }
}
</script>

<style scoped>
.homeContainer {
  margin: -0.5em;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  height: 100vh;
  width: 100vw;
  overflow: hidden;
  background: url('../../../static/images/pexels-photo-406014.jpeg');

  background-attachment: fixed;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}

.hamburgerButton {
  display: none;
}

.menuMobile {
  display: none;
}

.menu {
  bottom: -1px;
  margin: 0;
  width: 100%;
  position: fixed;
}
.menu ul{
  width: 70vw;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-around;
  flex-wrap: wrap;
  margin: auto;
  padding: 1em;
  background: white;
  border: 0.2em solid #d47b40;
  border-bottom: none;
  -webkit-box-shadow: 0px 0px 38px 2px rgba(0,0,0,0.75);
  -moz-box-shadow: 0px 0px 38px 2px rgba(0,0,0,0.75);
  box-shadow: 0px 0px 38px 2px rgba(0,0,0,0.75);
}

.menu li {
  list-style-type:none;
}


a {
  display: block;
  text-decoration: none;
  color: #5797B2;
  font-family: comfortaa;
  text-align: center;
  margin: 0.5em;
  width: 100%;
  font-size: 1.3em;
}

li a {
  border-bottom: 2px solid #ffffff;
}

li a:hover {
  border-bottom: 2px solid #BEEBFF;
}

.activeLink {
  border-bottom: 2px solid #BEEBFF;
}

a img {
  cursor: pointer;
  border: none;
}


  p {
    margin: 0;
    padding: 0;
    font-size: 2.5em;
    text-align: center;
    padding-left: 1em;
    /*font-family: 'Arvo', serif;*/
    display: inline;
    color: white;
    width: 40vw;
  }

@media (pointer:fine) {
  .homeContainer {
    margin: -0.5em;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    height: 100vh;
    width: 100vw;
    overflow: hidden;
    background: url('../../../static/images/pexels-photo-406014.jpeg');

    background-attachment: fixed;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
  }

  .hamburgerButton {
    display: none;
  }

  .menuMobile {
    display: none;
  }

  .menu {
    bottom: -1px;
    margin: 0;
    width: 100%;
    position: fixed;
  }
  .menu ul{
    width: 70vw;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-around;
    flex-wrap: wrap;
    margin: auto;
    padding: 1em;
    background: white;
    border: 0.2em solid #d47b40;
    border-bottom: none;
    -webkit-box-shadow: 0px 0px 38px 2px rgba(0,0,0,0.75);
    -moz-box-shadow: 0px 0px 38px 2px rgba(0,0,0,0.75);
    box-shadow: 0px 0px 38px 2px rgba(0,0,0,0.75);
  }

  .menu li {
    list-style-type:none;
  }


  a {
    display: block;
    text-decoration: none;
    color: #5797B2;
    font-family: comfortaa;
    text-align: center;
    margin: 0.5em;
    width: 100%;
    font-size: 1.3em;
  }

  li a {
    border-bottom: 2px solid #ffffff;
  }

  li a:hover {
    border-bottom: 2px solid #BEEBFF;
  }

  .activeLink {
    border-bottom: 2px solid #BEEBFF;
  }

  a img {
    cursor: pointer;
    border: none;
  }


    p {
      margin: 0;
      padding: 0;
      font-size: 2.5em;
      text-align: center;
      padding-left: 1em;
      /*font-family: 'Arvo', serif;*/
      display: inline;
      color: white;
      width: 40vw;
    }
}

@media (pointer:coarse) {
  /* .homeContainer {
    margin: -0.5em;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    height: 100vh;
    overflow: hidden;
    background: url('../../../static/images/pexels-photo-406014.jpeg');

    background-attachment: fixed;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
  }

  .hamburgerButton {
    position: fixed;
    top: 0em;
    width: 100%;
    height: 10em;
    padding: 1em;
    background: white;
  }

  .hamburgerButton img {
      height: 100%;
      padding: 1em;
  }

  .menu {
    display: none;
  }

  .menuMobile {
    background: #d47b40;
    padding: 1em;
    width: 90vw;
    height: 160vh;
    position: fixed;
    top: 0;
    font-size: 1.5em;
  }

  #close {
    text-align: right;
    color: white;
    font-size: 1.2em;
    padding: 1em;
  }

  .menuMobile li {
    list-style-type: none;
    padding: 0.2em;
    padding-left: 0;
  } */

}




/*comfortaa, cheque, raleway, john, joe, dosis, josefin, noto;*/
/*raleway, joe*/


</style>



// WEBPACK FOOTER //
// Home.vue?7da3c51a